const formatCurrency = (value, decimals = 0) => {
    return value ? (value / 100).toFixed(decimals).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : (0).toFixed(decimals);
};

export default formatCurrency;
